import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const openGetStarted = () => {
    window.open('https://forms.gle/rU28UfypBujmWmQK9', '_blank');
  };

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) element.scrollIntoView({ behavior: 'smooth' });
    setIsMobileMenuOpen(false);
  };

  const navLinks = [
    { label: 'How It Works', id: 'how-it-works' },
    { label: 'Tools', id: 'tools' },
    { label: 'Languages', id: 'languages' },
    { label: 'Pricing', id: 'pricing' },
    { label: 'Contact', id: 'contact' },
  ];

  return (
    <header
      data-testid="header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'glass-header shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-20">
          <a href="/" data-testid="logo-link" className="flex items-center gap-3">
            <img src="/neurobloom-logo.png" alt="Neurobloom" className="h-9 w-9 rounded-xl" />
            <span className="font-semibold text-xl text-[#1C1917] font-['DM_Sans']">Neurobloom</span>
          </a>

          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <button
                key={link.id}
                data-testid={`nav-${link.id}`}
                onClick={() => scrollToSection(link.id)}
                className="text-[#57534E] hover:text-[#1C1917] font-medium transition-colors text-sm"
              >
                {link.label}
              </button>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-4">
            <div className="flex items-center gap-3 border-r border-[#E7E5E4] pr-4">
              <a
                href="https://t-hub.co"
                target="_blank"
                rel="noopener noreferrer"
                title="T-Hub Recognised Startup"
              >
                <img
                  src="/thub-logo.svg"
                  alt="T-Hub Recognised"
                  className="h-7 w-7 object-contain hover:opacity-80 transition-opacity"
                />
              </a>
              <a
                href="https://www.startupindia.gov.in"
                target="_blank"
                rel="noopener noreferrer"
                title="DPIIT Recognised Startup"
              >
                <img
                  src="/dpiit-header.png"
                  alt="DPIIT Startup India"
                  className="h-5 object-contain hover:opacity-80 transition-opacity"
                />
              </a>
            </div>
            <Button
              data-testid="nav-cta-btn"
              onClick={openGetStarted}
              className="bg-[#2563EB] hover:bg-[#1D4ED8] text-white rounded-full px-5 py-2 text-sm font-semibold btn-shine"
            >
              Get 100 free calls →
            </Button>
          </div>

          <button
            data-testid="mobile-menu-btn"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2 text-[#1C1917]"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {isMobileMenuOpen && (
          <div
            data-testid="mobile-menu"
            className="md:hidden absolute top-20 left-0 right-0 bg-white shadow-lg border-t border-[#E7E5E4] py-4"
          >
            <div className="flex flex-col px-6 gap-4">
              {navLinks.map((link) => (
                <button
                  key={link.id}
                  onClick={() => scrollToSection(link.id)}
                  className="text-[#57534E] hover:text-[#1C1917] font-medium transition-colors text-left py-2"
                >
                  {link.label}
                </button>
              ))}
              <Button
                onClick={openGetStarted}
                className="bg-[#2563EB] hover:bg-[#1D4ED8] text-white rounded-full px-6 py-2.5 font-medium mt-2"
              >
                Get 100 free calls →
              </Button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
